import { Component } from '@angular/core';
import { ModalComponent } from '../../../lib/services/modal.service';
import { take } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UnitService } from '../../services/unit';
import * as unitActions from '../../actions/unit';
import { Store } from '@ngrx/store';
import * as fromUnit from '../../reducers';
import { PlatformLocation } from '@angular/common';
import each from 'lodash-es/each';

interface Address {
  lat: number;
  lng: number;
  address: string;
}

@Component({
  selector: 'mj-unit-add-sub-unit',
  templateUrl: './unit-add-sub-unit.component.html',
  styleUrls: ['./unit-add-sub-unit.component.scss'],
})
export class UnitAddSubUnitComponent extends ModalComponent {
  unit;
  form: FormGroup;
  availableParents = [];
  loading: boolean;
  address: Address = { lat: null, lng: null, address: null };

  constructor(
    private fb: FormBuilder,
    private unitService: UnitService,
    private store: Store<fromUnit.State>,
    private location: PlatformLocation,
    private snackbar: MatSnackBar
  ) {
    super();
    this.createForm();

    this.data.pipe(take(1)).subscribe(data => {
      this.availableParents = this._flatten(data['units']);
      this.unit = data['selected'];
      this.form.controls['parent'].setValue(this.unit.id);
    });

    this.location.onPopState(() => {
      history.go(1);
      this.resolve.next(null);
    });
  }

  private _flatten(collection: any[], flattened = []) {
    const self = this;
    if (flattened == null) {
      flattened = [];
    }
    each(collection, function(obj) {
      flattened.push(obj);
      return self._flatten(obj.children, flattened);
    });
    return flattened;
  }

  createForm() {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      address: ['', [Validators.required]],
      parent: ['', [Validators.required]],
    });
  }

  setAddress(place) {
    this.address.lat = place['geometry']['location'].lat();
    this.address.lng = place['geometry']['location'].lng();
    this.address.address = place['formatted_address'];
  }

  save() {
    this.loading = true;
    const newSubUnit = {
      name: this.form.get('name').value,
      parent_id: this.form.get('parent').value,
      address: this.address.address,
      lon: this.address.lng,
      lat: this.address.lat,
      same_as_parent_address: false,
    };

    this.unitService
      .addSubUnit(newSubUnit)
      .pipe(take(1))
      .subscribe(
        () => {
          this.loading = false;
          const unitId = Number(localStorage.getItem('unit_id'));
          this.store.dispatch(new unitActions.LoadUnits({ id: unitId }));
          this.resolve.next(null);
        },
        () => {
          this.snackbar.open('Something went wrong', null, {
            duration: 3000,
          });
        }
      );
  }

  cancel() {
    this.resolve.next(null);
  }
}
